import {useDashboard} from '../../../hooks/kpi/useDashboard'
import {ChartSalesPerPeriod} from './componente/charts/ChartSalesPerPeriod'

interface SalesPerPeriodProps {
  className: string
}

export function SalesPerPeriod({className}: SalesPerPeriodProps) {
  const {query} = useDashboard()

  const salesPerPeriod = query.data?.salesPerPeriod?.itens ?? {
    name: '',
    series: [],
    categories: [],
  }

  const totalPriceSalesPerPeriod = query.data?.salesPerPeriod?.total ?? 0
  const isLoading = query.isLoading

  return (
    <div className={`card card-flush ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Vendas no período</span>

          <span className='text-muted fw-semibold fs-7'>Vendas por unidade(s)</span>
        </h3>
      </div>

      {isLoading && (
        <div className='card-body pt-1 pb-4 d-flex flex-wrap flex-center p-4 px-10'>
          <div className='d-flex flex-center w-100'>
            <div className='text-center w-100 align-items-center justify-content-center'>
              <span>Carregando...</span>
            </div>
          </div>
        </div>
      )}
      {!isLoading && (
        <div className='card-body pt-1 pb-4 d-flex flex-wrap flex-start p-4 px-10'>
          <div className='d-flex flex-center w-100'>
            <ChartSalesPerPeriod
              className='w-100 h-100'
              salesPerPeriod={salesPerPeriod}
              totalPriceSalesPerPeriod={totalPriceSalesPerPeriod}
            />
          </div>
        </div>
      )}
    </div>
  )
}
